/*
  globals moment
*/
import dspxMessageTpl from '../../tpl/dspx-message.html';
import dspxEntHistoryTpl from '../../tpl/dspx-entity-history.html';

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('dspxMessage', [
    '$http',
    function($http) {
      return {
        restrict: 'E',
        replace: true,
        template: dspxMessageTpl, // '/app/modules/demandmgr/static/tpl/dspx-message.html',
        scope: {
          text: '@',
          type: '@',
        },
      };
    },
  ]);

  app.directive('dspxEntityHistory', [
    '$http',
    function($http) {
      return {
        restrict: 'E',
        replace: true,
        template: dspxEntHistoryTpl,
        //  '/app/modules/demandmgr/static/tpl/dspx-entity-history.html',
        scope: {
          logData: '=',
        },
        link: function($scope, element) {
          $scope.page = {
            number: 0,
            size: 5,
          };

          $scope.floor = Math.floor;

          $scope.setPage = function(page) {
            $scope.page.number = page;
          };

          $scope.reviewLog = function(state) {
            $scope.stateToReview = state;
            $(element[0])
              .find('.modal')
              .modal('show');
          };
        },
      };
    },
  ]);
})(window.angular);

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('dspxFeeManager', [
    function() {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: '/app/modules/demandmgr/static/tpl/dspx-fee-manager.html',
        scope: {
          ngModel: '=',
          level: '=',
        },
        link: function($scope, $element) {
          // fee management
          $scope.newFee = {
            name: null,
            type: 'margin',
            value: null,
          };

          $element
            .find('input[name="fee_name"], input[name="fee_value"]')
            .on('keyup', function() {
              if ($(this).val()) {
                $(this)
                  .removeClass('ng-invalid')
                  .removeClass('ng-touched');
              }
            });

          $scope.addFee = function() {
            var invalid = false;

            if (!$scope.newFee.name) {
              $element
                .find('input[name="fee_name"]')
                .addClass('ng-invalid')
                .addClass('ng-touched');
              invalid = true;
            }

            if (!$scope.newFee.value) {
              $element
                .find('input[name="fee_value"]')
                .addClass('ng-invalid')
                .addClass('ng-touched');
              invalid = true;
            }

            if (invalid) {
              return;
            }

            $scope.ngModel.push({
              name: $scope.newFee.name,
              type: $scope.newFee.type,
              value: $scope.newFee.value,
              level: $scope.level,
            });

            $scope.newFee = {
              name: null,
              type: $scope.newFee.type,
              value: null,
            };
          };

          $scope.deleteFee = function(index) {
            $scope.ngModel.splice(index, 1);
          };
        },
      };
    },
  ]);
})(window.angular);

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('multipleEmails', function() {
    var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;

    function validateAll(ctrl, validatorName, value) {
      if (Array.isArray(value)) {
        value = value.join(',');
      }

      var emails = ctrl.$isEmpty(value) ? [] : value.split(',');
      var validity = true;

      for (var i = 0; i < emails.length; i++) {
        emails[i] = emails[i].trim();
        if (!EMAIL_REGEXP.test(emails[i])) {
          validity = false;
        }
      }

      validity = ctrl.$isEmpty(value) || validity;
      ctrl.$setValidity(validatorName, validity);

      return validity ? emails : undefined;
    }

    return {
      restrict: 'A',
      require: 'ngModel',
      link: function postLink($scope, elem, attrs, modelCtrl) {
        function multipleEmailsValidator(value) {
          return validateAll(modelCtrl, 'multipleEmails', value);
        }

        function adjustSpaces(value) {
          var emails = value ? value.split(',') : [];
          for (var i = 0; i < emails.length; i++) {
            emails[i] = emails[i].trim();
          }

          return emails ? emails.join(', ') : '';
        }

        function renderEmails() {
          var newValue = adjustSpaces(modelCtrl.$viewValue);
          modelCtrl.$setViewValue(newValue);
          modelCtrl.$render();
        }

        elem.bind('blur', function() {
          $scope.$apply(function() {
            modelCtrl.$parsers.push(multipleEmailsValidator);
            renderEmails();
          });
        });
      },
    };
  });
})(window.angular);

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('uniqueName', [
    'advertiserApi',
    'agencyApi',
    'insertionOrderApi',
    'campaignApi',
    'creativeApi',
    function(
      advertiserApi,
      agencyApi,
      insertionOrderApi,
      campaignApi,
      creativeApi
    ) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, elem, attrs) {
          elem.bind('blur', function() {
            var name = elem.val();
            var entity = attrs.entity;

            if (
              name.length < attrs.minlength ||
              name.length > attrs.maxlength ||
              elem[0].validity.patternMismatch
            ) {
              // if name is not valid

              switch (entity) {
                case 'advertiser':
                  $scope.$apply(function() {
                    if (
                      $scope.advertiserForm &&
                      $scope.advertiserForm.hasOwnProperty('adv-name')
                    ) {
                      $scope.advertiserForm['adv-name'].$setValidity(
                        'unique',
                        true
                      );
                    }
                  });
                  break;

                case 'agency':
                  $scope.$apply(function() {
                    if ($scope.agencyForm && $scope.agencyForm.hasOwnProperty('name') ) {
                      $scope.agencyForm['name'].$setValidity('unique', true);
                    }
                    if ($scope.agencyForm && $scope.agencyForm.hasOwnProperty('short_name') ) {
                      $scope.agencyForm['short_name'].$setValidity('unique', true);
                    }
                  });
                  break;
                case 'io':
                  $scope.$apply(function() {
                    if ($scope.ioForm && $scope.ioForm.hasOwnProperty('name')) {
                      $scope.ioForm['name'].$setValidity('unique', true);
                    }
                  });
                  break;

                case 'campaign':
                  $scope.$apply(function() {
                    if (
                      $scope.campaignForm &&
                      $scope.campaignForm.hasOwnProperty('name')
                    ) {
                      $scope.campaignForm['name'].$setValidity('unique', true);
                    }
                  });
                  break;

                case 'creative':
                  $scope.$apply(function() {
                    if (
                      $scope.creativeForm &&
                      $scope.creativeForm.hasOwnProperty('creative-name')
                    ) {
                      $scope.creativeForm['creative-name'].$setValidity(
                        'unique',
                        true
                      );
                    }
                  });
                  break;
              }

              return;
            }

            switch (entity) {
              case 'advertiser':
                var advertiser = $scope.advertiser;

                $scope.$apply(function() {
                  // Check if advertiser name is unique
                  advertiserApi
                    .isAdvertiserNameUnique(
                      advertiser.name,
                      advertiser._id
                    )
                    .then(function(data) {
                      if (
                        $scope.advertiserForm &&
                        $scope.advertiserForm.hasOwnProperty('adv-name')
                      ) {
                        $scope.advertiserForm['adv-name'].$setValidity(
                          'unique',
                          data.unique
                        );
                      }
                    });
                });
                break;

              case 'agency':
                var agency = $scope.agency;

                $scope.$apply(function() {
                  // Check if agency name is unique
                  agencyApi.isAgencyNameUnique('name', agency.name, agency.id)
                      .then(function(data) {
                        if ($scope.agencyForm && $scope.agencyForm.hasOwnProperty('name') ) {
                          $scope.agencyForm['name'].$setValidity( 'unique', data.unique );
                        }
                      });
                  // Check if agency short name is unique
                  agencyApi.isAgencyNameUnique('short_name', agency.short_name, agency.id)
                      .then(function(data) {
                        if ($scope.agencyForm && $scope.agencyForm.hasOwnProperty('short_name') ) {
                          $scope.agencyForm['short_name'].$setValidity( 'unique', data.unique );
                        }
                      });
                });
                break;


              case 'io':
                var io = $scope.io;

                $scope.$apply(function() {
                  // Check if io name is unique
                  insertionOrderApi
                    .isIoNameUnique(io._advertiserId, io.name, io._id)
                    .then(function(data) {
                      if (
                        $scope.ioForm &&
                        $scope.ioForm.hasOwnProperty('name')
                      ) {
                        $scope.ioForm['name'].$setValidity(
                          'unique',
                          data.unique
                        );
                      }
                    });
                });
                break;

              case 'campaign':
                var campaign = $scope.campaign;

                $scope.$apply(function() {
                  // Check if campaign name is unique
                  campaignApi
                    .isCampaignNameUnique(
                      campaign._advertiserId,
                      campaign.name,
                      campaign._id
                    )
                    .then(function(data) {
                      //console.log(data,$scope.campaignForm);
                      if (
                        $scope.campaignForm &&
                        $scope.campaignForm.hasOwnProperty('name')
                      ) {
                        $scope.campaignForm['name'].$setValidity('unique', data.unique);
                      }
                    });
                });
                break;

              case 'creative':
                var creative = $scope.creative;

                $scope.$apply(function() {
                  // Check if creative name is unique
                  creativeApi
                    .isCreativeNameUnique(
                      creative._advertiserId,
                      creative.name,
                      creative.id
                    )
                    .then(function(data) {
                      if (
                        $scope.creativeForm &&
                        $scope.creativeForm.hasOwnProperty('creative-name')
                      ) {
                        $scope.creativeForm['creative-name'].$setValidity(
                          'unique',
                          data.unique
                        );
                      }
                    });
                });
                break;
            }
          });
        },
      };
    },
  ]);
})(window.angular);

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('dspxDynamicInputs', [
    function() {
      return {
        restrict: 'E',
        replace: true,
        templateUrl:
          '/app/modules/demandmgr/static/tpl/dspx-dynamic-inputs.html',
        scope: {
          ngModel: '=',
          max: '@max',
          pattern: '@pattern'
        },
        link: function($scope, $element) {
          $scope.newInput = null;

          $scope.inputCount = ['x'];

          $element.find('input').on('keyup', function() {
            if ($(this).val()) {
              $(this)
                .removeClass('ng-invalid')
                .removeClass('ng-touched');
            }
          });

          $scope.$watch('ngModel', function(newVal) {
            $scope.inputCount = ['x'];
            if (newVal && newVal.length > 0) {
              newVal.forEach(function() {
                $scope.inputCount.push('x');
              });
            }
          });

          $scope.addInput = function() {
            if ($scope.ngModel.length < $scope.max) {
              $scope.ngModel.push($scope.newInput);
              $scope.inputCount.push('x');
            }

            $scope.newInput = null;
          };

          $scope.deleteInput = function(index) {
            $scope.ngModel.splice(index, 1);
            $scope.inputCount.splice(index, 1);
          };
        },
      };
    },
  ]);
})(window.angular);

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('timezoneSelector', [
    function() {
      return {
        restrict: 'E',
        replace: false,
        scope: {
          disabled: '=disabled',
          ngModel: '=',
          noAutoDetect: '=',
        },
        template:
          '<osi-combobox ng-model="timezone" options="timezoneOptions"></osi-combobox>',

        link: function($attrs) {
          var getTimezones = function() {
            var timeZones = moment.tz.names();
            var offsetTmz = [];

            for (var i = 0; i < timeZones.length; i++) {
              let ival =  timeZones[i];
              let name = '(GMT' + moment.tz(timeZones[i]).format('Z') + ') ' + timeZones[i];
              offsetTmz.push({ value: ival, name: name });
            }

            return offsetTmz;
          };

          $attrs.timezoneOptions = getTimezones();

          if (!$attrs.noAutoDetect) {
            if (window.tz) {
              $attrs.timezone = window.tz;
            } else {
              $attrs.timezone =  moment.tz.guess();
            }
          } else {
            $attrs.$watch('ngModel', function () {
              $attrs.timezone = $attrs.ngModel;
            });
          }

          $attrs.$watch('timezone', function() {
            $attrs.ngModel = $attrs.timezone;
          });
          
          $attrs.$watch('disabled', function() {
            if ($attrs.disabled) {
              var tzInput = $('#timezone input');
              tzInput.attr('disabled', 'disabled');
              tzInput.attr('title', 'You cannot change the timezone.');
            }
          });

        },
      };
    },
  ]);
})(window.angular);

(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.directive('helpText', ['$sce', function ($sce) {

    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/app/modules/demandmgr/static/tpl/modal-window.html',
      scope: {
        title: '@',
        body: '@',
        modalWindow: '@'
      },
      transclude: true,

      link: function($scope, $element) {

        $scope.modal = false;

        $scope.$watch('modalWindow', function (newVal) {
          if (typeof newVal !== 'undefined') {
            $scope.modal = true;
          }
        });

        var $parentLabel = $element.parent('label');

        if ($parentLabel.length) {
          var $parentDiv = $parentLabel.parent('div');
          if ($parentDiv.length) {
            $parentDiv.css('paddingRight', '0');
          }
        }

        $scope.renderHtml = function(html_code) {
          return $sce.trustAsHtml(html_code);
        };

        $scope.open = function () {
          $($element[0]).find('.modal').modal('show');
        };

        $('.help-text-tooltip').tooltip({
          title: $scope.body,
          html: true,
          placement: 'top'
        });

      }
    };

  }]);

    app.directive('a', function() {
        return {
            restrict: 'E',
            link: function(scope, elem, attrs) {
                if(attrs.ngClick || attrs.href === '' || attrs.href === '#'){
                    elem.on('click', function(e){
                        e.preventDefault();
                    });
                }
            }
        };
    });

})(window.angular);
